import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

/**
 * Minimal react-i18next setup. English-only for v1 — the schema is in place
 * so additional locales can be dropped in without further wiring.
 *
 * Keys are flat and screen-prefixed:
 *   common.*                  shared widgets (Save, Cancel, …)
 *   home.*                    home-page chrome
 *   visitor.form.*            visitor form field labels
 *   travel.transport.*        transport tabs / labels
 *   reports.*                 report screens
 *   settings.*, password.*    account screens
 *
 * To migrate a string: replace the hardcoded English with `t('the.key')`
 * and add the key to en.json. Components don't need to be touched until
 * a real second language is required.
 */
void i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en } },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export default i18n;
